module.exports = __webpack_public_path__ + "static/media/Position_4.9de03802.jpg";